import React  from 'react'; // need this to use jsx (the html inside the array. noramally that would be in a string)
const value = {
  path:"mortgage_fraud",
  title:"Mortgage Fraud",
  date_modified:"Aug 2020",
  date_created:"Aug 2020",
  content:
[
<p align="justify">
Mortgage fraud is the act of falsifying your mortgage application information in order to sway the results of the application. This can include changing information such as: employment status, salary, amount of debt/assets, or the reason the property is being purchased (e.g. primary residence Vs. rental income). Mortgage fraud is common among new borrowers who don’t quite qualify for the mortgage size they need/want.
</p>
,
<p align="justify">
The consequences of mortgage fraud can be severe. If discovered before closing, the lender can cancel the loan. This would leave the borrower vulnerable to legal action by the seller, since they would no longer have the funding required to fulfill the agreement to purchase. The seller would also forfeit their deposit. If the fraud is discovered after close, the lender has the right to “call in” the loan; making the full amount due immediately. This typically results in the buyer having to sell the house -- in order to pay off the debt. Other consequences include: a credit score hit, potential criminal charges, and loss of job or legal action by employer (if employment information was falsified).
</p>
,
<p align="justify">
The term “mortgage fraud” can also refer to actions taken by mortgage brokers and/or lenders that have an adverse effect on mortgagors. It is generally a good idea to be on the look-out for mortgages where the deal seems too good to be true, or where the mortgage was approved last-minute using qualifications that had been previously denied. In these situations you could find yourself stuck with a mortgage including highly irregular and harmful rates or conditions. You should also be cautious of a sudden lack of communication from a broker, or situations where it seems like the broker is withholding information; such as mortgage terms, or kick-backs/incentives they are receiving from the lender.
</p>
],
  tags:["mortgage"]
}

export default value



// WEBPACK FOOTER //
// src/content/mortgageFraud.js